import { UserPermissionsEnum } from '@/enums/user-permissions.enum.js'

export enum UserPermissionRole {
  ADMIN = 'admin',
  SUPER_ADMIN = 'superadmin',
  MANAGER = 'manager',
  USER = 'user'
}

export type UserPermissionsType = {
  [UserPermissionsEnum.AccessInventoryReports]: 0 | 1
  [UserPermissionsEnum.AccessOrderReports]: 0 | 1
  [UserPermissionsEnum.AccessSalesReports]: 0 | 1
  [UserPermissionsEnum.AddToShoppingCart]: 0 | 1
  [UserPermissionsEnum.CrudItems]: 0 | 1
  id: number
  [UserPermissionsEnum.ManageOrders]: 0 | 1
  [UserPermissionsEnum.ManagePos]: 0 | 1
  [UserPermissionsEnum.ManageVendors]: 0 | 1
  [UserPermissionsEnum.ModifyBilling]: 0 | 1
  [UserPermissionsEnum.ModifyMenuPreferences]: 0 | 1
  [UserPermissionsEnum.ModifyOrganization]: 0 | 1
  organization_id: number
  [UserPermissionsEnum.PlaceOrders]: 0 | 1
  role: UserPermissionRole
  [UserPermissionsEnum.StartEndInventory]: 0 | 1
  [UserPermissionsEnum.TakeInventory]: 0 | 1
  user_id: number
}
